import { render } from "./OnboardingPopup.vue?vue&type=template&id=b2d060c4&scoped=true"
import script from "./OnboardingPopup.vue?vue&type=script&lang=js"
export * from "./OnboardingPopup.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./OnboardingPopup.vue?vue&type=style&index=0&id=b2d060c4&lang=less&module=true&scoped=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-b2d060c4"]])

export default __exports__